import { FormGroup, Input } from '@agro-club/agroclub-shared'
import { useTranslation } from 'react-i18next'
import { FC } from 'react'
import { FormikFieldsType } from 'modules/domain/types'

interface Props {
  formik: FormikFieldsType
}

export const FormFirstName: FC<Props> = ({ formik }) => {
  const { t } = useTranslation()

  return (
    <FormGroup error={formik.errors.first_name} label={t('common:firstName')} required>
      <Input
        placeholder={t('common:first_name_placeholder')}
        {...formik.getFieldProps('first_name')}
        invalid={!!formik.errors.first_name}
      />
    </FormGroup>
  )
}
